export interface Cartdata {
  cartData: any;
}
export interface RotationCartData {
  rotationCartData: any;
}

export interface DeliverDetailsData {
  deliveryDetailsMaster: any;
  local_purchase_number: any;
}

export interface ProductsData {
  productsList: any;
}

export const initialCartState: Cartdata = {
  cartData: {
    products: [],
    scheduleOrderData:[],
    showScheduleOrder:false,
    deliveryDetails: {},
    isMobile: true,
  },
};

export const initialRotationCartState: RotationCartData = {
  rotationCartData: {
    products: [],
    deliveryDetails: {},
    isMobile: true,
  },
};

export const initialDeliveryDetailsState = {
  deliveryDetailsMaster: {},
  local_purchase_number: [],
};

export const initialProductDetailsState = {
  productsList: [],
  update: true,
  lastUpdateTime: null,
};
